import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { SKIN } from '../../types/enums';
import { createSkinComponent } from '../../utils/skinComponent';
import { mergeSx } from '../../utils/styles';
import NeobetRaisedActionButton from '../skins/neobet/molecules/NeobetRaisedActionButton';

const styles = {
  button: {
    width: '100%',
    justifyContent: 'space-between',
    px: 2,
    py: 1.25,
    borderRadius: 2,
    alignItems: 'center',
  },
  neobetButton: {
    justifyContent: 'center',
    height: 48,
  },
  actionIcon: {
    fontSize: 20,
  },
} as const;

export type KycVerificationActionButtonProps = {
  disabled?: boolean;
  label: ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

const DefaultKycVerificationActionButton = ({ disabled, label, onClick, sx }: KycVerificationActionButtonProps) => (
  <Button
    variant='contained'
    sx={mergeSx(styles.button, sx)}
    disabled={disabled}
    onClick={onClick}
    endIcon={<ArrowForwardIosIcon sx={styles.actionIcon} />}
  >
    {label}
  </Button>
);

const NeobetKycVerificationActionButton = ({ disabled, label, onClick, sx }: KycVerificationActionButtonProps) => (
  <NeobetRaisedActionButton
    fullWidth
    disabled={disabled}
    label={label}
    onClick={onClick}
    sx={mergeSx(styles.button, styles.neobetButton, sx)}
  />
);

const KycVerificationActionButton = createSkinComponent(DefaultKycVerificationActionButton, {
  [SKIN.NEOBET]: NeobetKycVerificationActionButton,
});

export default KycVerificationActionButton;
